import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { AcceleratorCourseFeedback } from '../accelerator-course-feedback-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';

export function getSetup(util: UtilityService): GridSetup<AcceleratorCourseFeedback> {
	return {
		rowName: { singular: 'Feedback', plural: 'Feedbacks' },
		getRowKey: row => '' + row.feedbackResponseId,
		stateKey: 'experience-courses-accelerator-course-feedback-grid',
		renderRowClasses: row => [],
		multiselect: false,
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
